import { number, oneOf, shape, string } from 'prop-types';
import DataSourceTypes from 'constants/DataSourceTypes';

export default shape({
    id: string.isRequired,
    linksPerDomain: number.isRequired,
    source: oneOf([DataSourceTypes.ALL_LINKS, DataSourceTypes.NEW_LINKS, DataSourceTypes.LOST_LINKS]),
    url: string.isRequired,
});
